import type { SVGProps } from 'react';
import * as React from 'react';

const UserGroupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/user-group">
      <g id="Icon">
        <path
          d="M12 10.7996C13.9882 10.7996 15.6 9.18783 15.6 7.19961C15.6 5.21138 13.9882 3.59961 12 3.59961C10.0117 3.59961 8.39995 5.21138 8.39995 7.19961C8.39995 9.18783 10.0117 10.7996 12 10.7996Z"
          fill="currentColor"
        />
        <path
          d="M7.19995 9.59961C7.19995 10.9251 6.12543 11.9996 4.79995 11.9996C3.47447 11.9996 2.39995 10.9251 2.39995 9.59961C2.39995 8.27413 3.47447 7.19961 4.79995 7.19961C6.12543 7.19961 7.19995 8.27413 7.19995 9.59961Z"
          fill="currentColor"
        />
        <path
          d="M1.78872 18.3904C1.58523 18.2721 1.42821 18.0858 1.35891 17.8608C1.25558 17.5254 1.19995 17.169 1.19995 16.7996C1.19995 14.8114 2.81173 13.1996 4.79995 13.1996C5.42635 13.1996 6.01539 13.3596 6.52843 13.6409C5.2719 14.8782 4.43291 16.5386 4.24169 18.3917C4.21412 18.6589 4.22562 18.9226 4.27191 19.1767C3.37268 19.0983 2.53029 18.8215 1.78872 18.3904Z"
          fill="currentColor"
        />
        <path
          d="M19.7285 19.1766C20.6276 19.0982 21.4698 18.8214 22.2112 18.3904C22.4147 18.2721 22.5717 18.0858 22.641 17.8608C22.7443 17.5254 22.8 17.169 22.8 16.7996C22.8 14.8114 21.1882 13.1996 19.2 13.1996C18.5737 13.1996 17.9848 13.3595 17.4718 13.6408C18.7284 14.8781 19.5675 16.5385 19.7587 18.3917C19.7863 18.6589 19.7748 18.9226 19.7285 19.1766Z"
          fill="currentColor"
        />
        <path
          d="M21.6 9.59961C21.6 10.9251 20.5254 11.9996 19.2 11.9996C17.8745 11.9996 16.8 10.9251 16.8 9.59961C16.8 8.27413 17.8745 7.19961 19.2 7.19961C20.5254 7.19961 21.6 8.27413 21.6 9.59961Z"
          fill="currentColor"
        />
        <path
          d="M6.36455 19.4287C6.12563 19.2124 5.99902 18.897 6.0321 18.5764C6.34384 15.5556 8.89685 13.1996 12.0001 13.1996C15.1034 13.1996 17.6564 15.5556 17.9682 18.5764C18.0012 18.897 17.8746 19.2124 17.6357 19.4287C16.1454 20.7778 14.1687 21.5996 12.0001 21.5996C9.83152 21.5996 7.85486 20.7778 6.36455 19.4287Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default UserGroupIcon;
